import React from 'react';
import { Button } from 'components/shared/uniform';

const EditProfileButton = (props) => {
  return (
    <Button
      onClick={props.onClick}
      icon="edit"
      size={props.size || 'medium'}
      style={props.minimal ? 'minimal' : null}
      text={props.hideText ? undefined : 'Edit Profile'}
      type={props.type}
    />
  );
};

EditProfileButton.propTypes = {
  onClick: React.PropTypes.func.isRequired,
  hideText: React.PropTypes.bool,
  minimal: React.PropTypes.bool,
  size: React.PropTypes.string,
  type: React.PropTypes.string.isRequired,
};

export default EditProfileButton;
